<div class="dialog">
  <h1 mat-dialog-title>Registration</h1>
  <div
    class="content"
    mat-dialog-content
  >
    Please contact your local Camp Bow Wow<sup>&#174;</sup>
    to confirm we have your correct email address on file.
    <br><br>
    Or try again with a different email address.
  </div>
  <div
    mat-dialog-actions
    class="row no-gutters"
  >
    <div class="col-12">
      <button
        type="button"
        class="btn btn-danger btn-block mb-3"
        (click)="data.startOverFn()"
      >Start over with a new email</button>
      <button
        type="button"
        class="btn btn-outline-danger btn-block"
        (click)="data.contactCbwFn()"
      >Contact my local Camp Bow Wow<sup>&#174;</sup></button>
    </div>
  </div>
</div>
